import state from './moduleMonthlyComplianceState.js';
import mutations from './moduleMonthlyComplianceMutations.js';
import actions from './moduleMonthlyComplianceActions.js';
import getters from './moduleMonthlyComplianceGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
